
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { download } from "@/functions/global.function";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { AxiosResponse } from "axios";
import NewsDetailItem1 from "@/components/items/news/NewsDetailItem1.vue";
import NewsDetailItem2 from "@/components/items/news/NewsDetailItem2.vue";
import NewsDetailItem3 from "@/components/items/news/NewsDetailItem3.vue";

@Component({
  components: {
    NewsDetailItem3,
    NewsDetailItem2,
    NewsDetailItem1,
    AppFooter,
    AppNavbarSecondary,
  },
  filters,
})
export default class NewsDetail extends Vue {
  @Action("getSchoolNewsDetail", { namespace: "school" })
  private getSchoolNewsDetail: any;

  private news: any = null;

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private created() {
    this.getSchoolNewsDetail({
      params: {
        id: this.$route.params.id,
      },
      success: (response: AxiosResponse) => {
        this.news = response.data.data;
      },
    });
  }

  private onDownload() {
    download(this.news?.attachment);
  }
}
